module.exports = __webpack_public_path__ + "static/media/logo_matrimur.16d6054f.jpg";